  function swymCallbackFn() {
    var replayAddToCartOriginalFn = _swat.replayAddToCart;
    window._swat.replayAddToCart = function() {
      var successCallbackFn = arguments[2];
      arguments[2] = function(data) {
        if (successCallbackFn && updateThirdPartyCartFn) {
          successCallbackFn(data);
          updateThirdPartyCartFn(data);
        };
      }
      replayAddToCartOriginalFn.apply(this, arguments);
    };
    function updateThirdPartyCartFn(productData) {
      setTimeout(function(){
        $.getJSON('/cart.js', function(cart){
          var result = cart.item_count;
          $(".cart__count").text(result);
          $(".cart-link__bubble").addClass('cart-link__bubble--visible');
        });
      }, 1000);
    }
  }
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(swymCallbackFn);
